import type { VizProps } from "./registry.js";

/**
 * Trusted raw HTML — the explicit escape hatch from the safe-markdown
 * default. Use only when the wiki author is trusted (which they are: pages
 * live in the git repo).
 */
export function HtmlViz({ source }: VizProps) {
  return (
    <div
      className="dw-embed dw-embed-html"
      dangerouslySetInnerHTML={{ __html: source }}
    />
  );
}
